<template>
    <div class="flex flex-col h-full relative">

        <div class="flex  w-full h-full items-center justify-center"
             v-if="!is_game_timed && gamer.current_question == gamer.max_questions">
            <div class="bg-red-300 p-4">
                {{ $t('hedef_sayi_bulalim_gamer_wait_description') }}
            </div>
        </div>

        <main class="h-full flex flex-col items-center relative" v-else>
            <!-- soru -->
            <div
                class="flex flex-col space-y-4 h-4/6  pb-3 lg:pb-6 2xl:pb-10 w-full items-center justify-end font-bold">
                <!-- İlerleme -->

                <div class="flex space-x-2 w-1/2 items-center justify-center pt-4" v-if="!is_game_timed">
                    <div class="text-right text-xl">{{ `${max_questions}/${gamer.current_question + 1}` }}</div>
                    <div class="flex w-full items-center justify-center">
                        <div class="w-full bg-gray-200 rounded-full h-2.5  ">
                            <div class="games-hedef-sayi-bulalim-secondary-gridant h-2.5 rounded-full"
                                 :style='`width: ${((gamer.current_question + 1) * 100) / max_questions}%`'></div>
                        </div>
                    </div>
                </div>

                <div
                    class="flex items-center justify-center pt-4 text-5xl lg:text-7xl"
                >
                    <div class="flex item-center space-x-3 items-center justify-center games-hedef-sayi-bulalim-text-color-primary ">
                        <div>{{ target }}</div>
                    </div>
                </div>

                <div class="flex space-x-2 pb-4 items-center justify-center">
                    <button class="border-b-4  games-hedef-sayi-bulalim-gridant-islem p-2 rounded-xl cursor-pointer"
                            v-for="o, key in operations.filter(i => i.visible).length == 0 ? operations : operations.filter(i => i.visible)"
                            :key="key"
                            :class="!islem_goster && secilen_islem != o.title && 'opacity-20'"
                            @click="islem_goster && clickIslem(o)"
                    >
                        <img :src="o.icon" class="w-12" alt="">
                    </button>
                </div>
            </div>

            <!-- cevap -->
            <div class="h-4/6 w-full ">
                <div class="flex justify-center item-center space-x-5">
                    <div
                        v-for="c in choices"
                        :key="c.number"
                        class="font-bold text-black cursor-pointer"
                        v-show="c.status && c.number != selectedAnswer"
                        :class="(!numara_goster && secilen_key != c.key) || !c.show ? 'opacity-20' : ''"
                        @click="numara_goster && c.show && clickAnswer(c)">
                        <bg
                            :class="phoneScreen.landscape && 'text-2xl lg:text-5xl' || 'text-3xl lg:text-5xl'"
                            class="font-bold ">
                            {{ c.number }}
                        </bg>
                    </div>
                </div>

                <!-- puanı basalım -->
                <div class="flex items-center justify-center space-x-2 games-hedef-sayi-bulalim-text-color-primary" :class="phoneScreen.landscape  && 'mt-2 lg:mt-6 2xl:mt-10' || 'mt-10'">
                    <div class="text-right text-sm lg:text-3xl font-bold">
                        {{ notification?.praise }}
                    </div>
                    <div class="transform -rotate-12 text-xs font-bold lg:text-lg "
                        v-if="notification?.point">+{{ notification?.point }}
                    </div>
                </div>

                <div class="flex items-center justify-center">
                    <div class="flex space-x-2 mt-4">
                        <GameButton @click="getQuestion">{{ $t('hedef_sayi_bulalim_title_button_new_question') }}</GameButton>
                        <GameButton @click="clearQuestion">{{ $t('hedef_sayi_bulalim_title_button_clear') }}</GameButton>
                    </div>
                </div>
            </div>



        </main>
    </div>
</template>

<script setup>
import {ref, watch, onMounted} from "vue"
import useSound from '../../sounds'
import {useScreen} from 'vue-screen'
import GameButton from '../other/Button.vue'
import Bg from '../other/Bg.vue'
import i18next from 'i18next'

const emit = defineEmits(['screen', 'add_point'])
const props = defineProps(['gamer', 'volume', 'time', 'operations', 'hard', 'is_game_timed', 'gamer_count', 'max_questions'])
const choices = ref([])
const notification = ref([])
const selectedAnswer = ref(null);

const {soundStart, soundSetVolume} = useSound({files_url:i18next.t('files_url')})

const phoneScreen = useScreen()
const lenWrong = ref(0)
const timeWrong = ref(0)
const target = ref(null)
const secilen_numaralar = ref([])
const answer = ref(0)
const secilen_islem = ref(false)
const numara_goster = ref(true)
const islem_goster = ref(false)
const numara_1 = ref(false)
const numara_2 = ref(false)
const secilen_key = ref(false)

const start = () => getQuestion()

soundSetVolume(props.volume)
onMounted(() => start())

const clickAnswer = (c) => {
    //soundStart(2)
    let choiceIndex = choices.value.findIndex(i => i.key == c.key);
    if (!numara_1.value) {
        numara_1.value = c.number
        choices.value[choiceIndex].show = true
        secilen_key.value = c.key

        numara_goster.value = !numara_goster.value
        islem_goster.value = !islem_goster.value
    } else {
        numara_2.value = c.number
        choices.value[choiceIndex].status = false
        secilen_numaralar.value = []

        let numara1Index = choices.value.findIndex(i => i.key == secilen_key.value);
        choices.value[choiceIndex].status = false
        choices.value[numara1Index].status = false

        let new_answer = 0;
        if (secilen_islem.value == "topla") {
            new_answer = numara_1.value + numara_2.value
        } else if (secilen_islem.value == "cikar") {
            new_answer = numara_1.value - numara_2.value
        } else if (secilen_islem.value == "carp") {
            new_answer = numara_1.value * numara_2.value
        } else if (secilen_islem.value == "bol") {
            new_answer = numara_1.value / numara_2.value
        }

        choices.value.push({
            number: Number(new_answer.toFixed(2)),
            status: true,
            show: true,
            current: false,
            key: new Date().getTime()
        })

        secilen_islem.value = false
        numara_1.value = false
        numara_2.value = false
        //iki numarada seçildi ise işlem yapabiliriz artık
        checkAnswer(new_answer)
    }
}

const checkAnswer = (answer) => {
    let statusCount = choices.value.filter(i => i.status).length
    if (answer == target.value && statusCount == 1) {
        setAnswer(true)
    } else {
        let statusCount = choices.value.filter(i => i.status).length
        if (statusCount == 1) {
            setAnswer(false)
        }
    }
}

const clickIslem = (o) => {
    secilen_islem.value = o.title
    let numara1Index = choices.value.findIndex(i => i.key == secilen_key.value);
    choices.value[numara1Index].show = false

    numara_goster.value = !numara_goster.value
    islem_goster.value = !islem_goster.value
}

watch(props, (props, _) => {
    if (timeWrong.value - props.time > 3 && timeWrong.value > 0) {
        lenWrong.value = 0
        timeWrong.value = 0
        notification.value = {
            praise: i18next.t('hedef_sayi_bulalim_info_continue'),            point: 0
        }
    } else {
        if (timeWrong.value > 0) {
            const remainingTime = (4 - (timeWrong.value - props.time));
            if (remainingTime < 4) {
                notification.value = {
                    praise: i18next.t('hedef_sayi_bulalim_info_wait', {time: remainingTime}),
                    point: 0
                }
            }
        }
    }
})

const setAnswer = (status) => {
    const notificationArr = []
    notificationArr.push(i18next.t('hedef_sayi_bulalim_info_notification_1'))
    notificationArr.push(i18next.t('hedef_sayi_bulalim_info_notification_2'))
    notificationArr.push(i18next.t('hedef_sayi_bulalim_info_notification_3'))
    notificationArr.push(i18next.t('hedef_sayi_bulalim_info_notification_4'))
    selectedAnswer.value = answer;

    if (status) {
        soundStart(0)
        lenWrong.value = 0

        const period = (props.gamer.bestAnswer + 1) % 4;
        const newPoint = period == 0 ? 30 : 10;
        const newGamer = {
            ...props.gamer,
            bestAnswer: props.gamer.bestAnswer + 1,
            point: props.gamer.point + newPoint,
            true: props.gamer?.true + 1,
            max_questions: props.max_questions,
            appear_qestion: props.gamer.appear_qestion + 1
        }

        emit('add_point', {...newGamer})

        const notificationKey = newGamer.bestAnswer > notificationArr.length ? notificationArr.length - 1 : newGamer.bestAnswer - 1;

        notification.value = {
            praise: notificationArr[notificationKey],
            point: newPoint
        }

        setTimeout(() => getQuestion(), 100);
    } else {
        soundStart(1)
        const newGamer = {
            ...props.gamer,
            bestAnswer: 0,
            appear_qestion: props.gamer.appear_qestion + 1
        }

        emit('add_point', newGamer)
        notification.value = {
            praise: i18next.t('hedef_sayi_bulalim_info_error'),
            point: 0
        }


        clearQuestion();
    }
}

const clearQuestion = () => {
    let choicesMap = choices.value.map(i => {
        i.status = true
        return i
    })

    choices.value = choicesMap
    answer.value = 0
    secilen_islem.value = false

    choices.value = choices.value.filter(i => i.current).map(i => {
        i.show = true
        i.status = true
        return i;
    })

    numara_goster.value = true
    islem_goster.value = false
    numara_1.value = false
    numara_2.value = false
    secilen_key.value = false
}

const setScreen = (screen) => {
    emit('screen', screen)
}

const reset = () => {
    target.value = null
    secilen_numaralar.value = []
    answer.value = 0
    secilen_islem.value = false

    numara_goster.value = true
    islem_goster.value = false
    numara_1.value = false
    numara_2.value = false
    secilen_key.value = false
}

const findDivisors = (number) => {
    var divisors = [];
    for (var i = 1; i <= number; i++) {
        if (number % i === 0) {
            divisors.push(i);
        }
    }
    return divisors;
}

const getQuestion = async () => {
    reset();
    let deneme_sayisi = 1000;

    emit('add_point', {
        ...props.gamer,
        current_question: props.gamer.current_question + 1,
    })

    for await (const num of [...Array(deneme_sayisi).keys()]) {
        let newTarget = setTarget()
        if (newTarget < 101 && newTarget > 1) {
            target.value = newTarget
            choices.value = shuffle([...secilen_numaralar.value])
            break;
        }

        if (num == deneme_sayisi - 1) {
            target.value = newTarget
            choices.value = shuffle([...secilen_numaralar.value])
            break;
        }
    }
}

const setTarget = () => {
    let hardQuestionCount = [2, 3, 4];
    let hardNumberSize = [10, 20, 30]
    let operations = props.operations.filter(i => i.visible);
    operations = operations.length == 0 ? props.operations : operations;

    let hardArr = shuffle(Array.from({length: hardNumberSize[props.hard]}, (_, index) => index + 1));

    secilen_numaralar.value = []
    for (let i = 0; i < hardQuestionCount[props.hard]; i++) {
        let number = hardArr[i];
        if (operations.filter(i => i.title == "bol").length == operations.length && i == 0) {
            hardArr.map(i => {
                if (findDivisors(i) > hardQuestionCount[props.hard]) number = i
            })
        }

        secilen_numaralar.value.push({
            number: number,
            status: true,
            show: true,
            current: true,
            key: new Date().getTime() + i
        })
    }

    let _target = secilen_numaralar.value[0].number;
    for (let i = 0; i < secilen_numaralar.value.length - 1; i++) {
        const randomOperationsIndex = Math.floor(Math.random() * operations.length);
        if (operations[randomOperationsIndex].title == "topla") {
            _target = _target + secilen_numaralar.value[i + 1].number
        } else if (operations[randomOperationsIndex].title == "cikar") {
            _target = _target - secilen_numaralar.value[i + 1].number
        } else if (operations[randomOperationsIndex].title == "carp") {
            _target = _target * secilen_numaralar.value[i + 1].number
        } else if (operations[randomOperationsIndex].title == "bol") {
            if (_target % secilen_numaralar.value[i + 1].number == 0) {
                _target = _target / secilen_numaralar.value[i + 1].number
            } else {
                //let bolenler = shuffle(findDivisors(_target))
                let bolenler = findDivisors(_target).filter(i => i != _target && !secilen_numaralar.value.map(x => x.number).includes(i))

                if (bolenler.length > 1) {
                    let newNumber = shuffle(bolenler)[0]
                    secilen_numaralar.value[i + 1].number = newNumber
                    _target = _target / newNumber
                } else {
                    return 1001
                }
            }
        }
    }

    return _target;
}

const shuffle = (array) => {
    let currentIndex = array.length, randomIndex;
    // While there remain elements to shuffle...
    while (currentIndex != 0) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;
        // And swap it with the current element.
        [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
    }
    return array;
}
</script>
